<section class="main-container">
    <!-- Main Content -->
    <div class="center-container col-span-12!">
        <div class="bg-white rounded-3xl sm:p-6 p-4">
            <p class="text-generic mb-8">{{'ACTIVITY_STATUS.SUBMITTED_ACTIVITY' | translate}}</p>
            <!-- table -->
            <app-data-table [columns]="columns" [data]="transactions" [showSearch]="true" [showFilter]="true"
                [filterOptions]="filterOptions" [defaultFilter]="defaultFilter"
                [gridTemplateColumns]="gridTemplateColumns" [showPagination]="true" [totalRecords]="total" [page]="page"
                [pageSize]="10" (pageChange)="loadPage($event)"
                (applyFilters)="onFilterApply($event)" (resetFilters)="onFilterReset()"></app-data-table>
        </div>
    </div>
</section>